export const CLUB = 'C';
export const SELECCION = 'S';
